import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SvgIconUtils } from '../../../../common-library/svg-icon/svg-icon-utils';

@Component({
  selector: 'ula-modal-prompt',
  templateUrl: './modal-prompt.component.html',
  styleUrls: [ '../modal-composites.styles.css' ]
})
export class ModalPromptComponent implements OnInit {
  @Input() title = '';
  @Input() shouldShowCloseButton: boolean = true;
  @Output() onHidden: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modal') modal;

  closeIconId: string = 'icon-close-x';
  closeIconPath: string = '';

  ngOnInit() {
    this.closeIconPath = SvgIconUtils.appendDefaultToIconPath(this.closeIconId);
  }

  close() {
    this.modal.hide();
  }

  relayOnHidden($event): void {
    this.onHidden.emit($event);
  }
}
